/* eslint-disable */
import { produce } from "immer";
import {
  PAYOUT_RATE_FETCH_START,
  PAYOUT_RATE_FETCH_SUCCESS,
  PAYOUT_RATE_FETCH_FAILURE,
} from "../actions/types";

const payoutRate = (
  state = {
    payoutRateFetching: false,
    payoutRateData: [],
    payoutRateError: null,
  },
  action,
) => {
  switch (action.type) {
    case PAYOUT_RATE_FETCH_START:
      return produce(state, (draft) => {
        draft.payoutRateFetching = true;
      });
    case PAYOUT_RATE_FETCH_SUCCESS:
      return produce(state, (draft) => {
        draft.payoutRateFetching = true;
        draft.payoutRateData = action.data;
        draft.payoutRateFetching = false;
      });
    case PAYOUT_RATE_FETCH_FAILURE:
      return produce(state, (draft) => {
        draft.payoutRateFetching = false;
        draft.payoutRateError = action.error;
      });
    default:
      return state;
  }
};

export default payoutRate;
